var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.579,
    height: 16.608,
    viewBox: "0 0 16.579 16.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".phoneCall{fill:none;stroke:#3553b2;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "phoneCall",
    d: "M11.4,3.872a3.591,3.591,0,0,1,2.837,2.837M11.4,1a6.463,6.463,0,0,1,5.709,5.7m-.718,5.731v2.154a1.436,1.436,0,0,1-1.565,1.436,14.211,14.211,0,0,1-6.2-2.2A14,14,0,0,1,4.322,9.51a14.211,14.211,0,0,1-2.2-6.226A1.436,1.436,0,0,1,3.547,1.718H5.7A1.436,1.436,0,0,1,7.137,2.953a9.221,9.221,0,0,0,.5,2.018,1.436,1.436,0,0,1-.323,1.515L6.4,7.4a11.49,11.49,0,0,0,4.309,4.309l.912-.912a1.436,1.436,0,0,1,1.515-.323,9.22,9.22,0,0,0,2.018.5,1.436,1.436,0,0,1,1.235,1.458Z",
    transform: "translate(-1.361 -0.172)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phoneCall.93a658fb.svg";
export { ForwardRef as ReactComponent };